import { Row } from "@tanstack/react-table";
import { ModelScreenerRow } from "@models/model-screener/entities/modelScreenerData";
import React, { useMemo } from "react";
import { MSTableStickyConstants } from "@pages/managed-accounts/model-screener/constant";
import { MSTableVirtualizedCell } from "@pages/managed-accounts/model-screener/components/model-screener-table/table/table-virtualized-cell";
import { VirtualItem } from "@tanstack/react-virtual";

type MSTableVirtualizedColumnProps = {
  row: Row<ModelScreenerRow>;
  columnVirtualizerItems: VirtualItem<Element>[];
};

export const MSTableVirtualizedColumn = React.memo(
  ({ row, columnVirtualizerItems }: MSTableVirtualizedColumnProps) => {
    const visibleCells = row.getVisibleCells();

    const virtualizedColumns = useMemo(
      () =>
        columnVirtualizerItems?.slice(
          MSTableStickyConstants.LastBodyColumnIndex + 1,
        ),
      [columnVirtualizerItems],
    );

    const virtualizedCells = useMemo(
      () =>
        virtualizedColumns?.map((virtualCol) => {
          const cell = visibleCells[virtualCol.index];
          if (!cell) return null;

          return (
            <MSTableVirtualizedCell
              key={`virtual-${row.original.id}-${virtualCol.index}`}
              cell={cell}
            />
          );
        }),
      [virtualizedColumns, visibleCells, row.original.id],
    );

    return <>{virtualizedCells}</>;
  },
  (prevProps, nextProps) => {
    return (
      prevProps.row !== nextProps.row &&
      prevProps.columnVirtualizerItems !== nextProps.columnVirtualizerItems
    );
  },
);
